<template>
  <section>
    <ClientDataTable :clients="clients" v-if="clients"></ClientDataTable>
  </section>
</template>

<script>
  import ClientDataTable from "../../util/Clients/ClientDataTable";
  import axios from 'axios'

  export default {
    name: "ClientsPage",
    components: {ClientDataTable},
    data() {
      return {
        clients: null
      }
    },
    methods: {
      getClients() {
        axios.get(process.env.API_URL + '/clients?inactive=true')
          .then((response) => {
            this.clients = response.data;
          })
          .catch((error) => {
            console.log(error.response.error);
          })
      }
    },
    mounted() {
      this.getClients();
    },
    computed: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/ClientsPage.vue